import { css } from '@emotion/react'

export const tableRow = css`
  max-width: 100%;
`

export const tableCell = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const rowCountContainer = css`
  display: flex;
  align-items: center;
`

export const statusContainer = css`
  display: flex;
`

export const processingSpinner = css`
  margin-left: 5px;
`

export const hideOverflow = css`
  overflow: hidden;
`
